/* Sample builder - core state and rendering.

   Selections are held in memory only: a half-built box restored days later
   would silently contain discontinued scents. The cart line carries the picks
   as a line item property, so they appear on the order and packing slip
   instead of being typed into order notes at checkout. */
window.croSampler = (function () {
  var all = [], pick = [], max = 12;

  function load(root) {
    var tag = root.querySelector('[data-cro-scents]');
    try { all = JSON.parse(tag.textContent) || []; } catch (e) { all = []; }
    return all;
  }

  function has(h) { return pick.indexOf(h) > -1; }

  function toggle(h) {
    var i = pick.indexOf(h);
    if (i > -1) { pick.splice(i, 1); return true; }
    if (pick.length >= max) return false;
    pick.push(h);
    return true;
  }

  function match(s, q, mood, fam) {
    if (mood && s.m !== mood) return false;
    if (fam && (s.f || []).indexOf(fam) < 0) return false;
    if (q && s.t.toLowerCase().indexOf(q) < 0) return false;
    return true;
  }

  function facets() {
    var m = {}, f = {};
    all.forEach(function (s) {
      if (s.m) m[s.m] = 1;
      (s.f || []).forEach(function (x) { f[x] = 1; });
    });
    return { moods: Object.keys(m).sort(), fams: Object.keys(f).sort() };
  }

  return {
    load: load, has: has, toggle: toggle, match: match, facets: facets,
    all: function () { return all; },
    pick: function () { return pick; },
    max: function (n) { if (n) max = n; return max; },
    clear: function () { pick = []; }
  };
})();
